import { AsyncPipe, CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslatePipe } from '@ngx-translate/core';
import { map, Observable, startWith } from 'rxjs';
import { TreeNode } from '../tree-container/tree-container.component';

@Component({
   
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    TranslatePipe,
    MatAutocompleteModule,
    ReactiveFormsModule,
    AsyncPipe,
  ],
  selector: 'siat-search-node',
  template: `
    <mat-form-field class="w-full" appearance="outline">
      <mat-label
        >{{ 'GENERAL.search' | translate }} {{ 'STRUTTURE.singular' | translate }}</mat-label
      >
      <input
        type="text"
        [attr.aria-label]="'FIELDS.STRUCTURE.label' | translate"
        matInput
        [formControl]="filterControl"
        [placeholder]="'FIELDS.STRUCTURE.placeholder' | translate"
        [matAutocomplete]="auto"
        [id]="'search-node-' + levelIndex" 
        aria-activedescendant="auto"/>
      <mat-autocomplete
        #auto="matAutocomplete"
        [displayWith]="displayFn"
        (optionSelected)="onItemSelected($event.option.value)">
        @for (option of filteredOptions | async; track option) {
          <mat-option [value]="option">{{ option.name }}</mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  `,
})
export class SearchNodeComponent implements OnInit {
  /**
   * The level index input.
   */
  @Input()
  levelIndex = 0;

  /**
   * The level data input.
   */
  @Input()
  levelData: TreeNode[] = [];

  /**
   * The filter control.
   */
  @Input()
  filterControl = new FormControl<TreeNode | string>('');

  /**
   * The filtered options.
   */
  filteredOptions: Observable<TreeNode[]>;

  /**
   * The on select event emitter.
   */
  @Output()
  onSelectEventEmitter = new EventEmitter<number>();

  /**
   * @inheritdoc
   */

  ngOnInit() {
    const expandedItem = this.levelData.find(node => node.expanded);
    this.filterControl.setValue(expandedItem || null);
    this.filteredOptions = this.filterControl.valueChanges.pipe(
      startWith(''),
      map(value => {
        const name = typeof value === 'string' ? value : value?.name;
        return name ? this._filter(name as string) : this.levelData.slice();
      })
    );
  }

  /**
   * Display function.
   */
  displayFn(node: TreeNode): string {
    return node && node.name ? node.name : '';
  }

  /**
   * Filter function.
   */
  private _filter(name: string): TreeNode[] {
    const filterValue = name.toLowerCase();

    return this.levelData.filter(option => option.name.toLowerCase().includes(filterValue));
  }

  /**
   * On item selected event emit item index.
   */
  onItemSelected(item: TreeNode): void {
    const selectedIndex = this.levelData.findIndex(level => level === item);

    this.onSelectEventEmitter.emit(selectedIndex);
  }
}
